<template>
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
    <div class="bg-white rounded-xl shadow-2xl w-full max-w-5xl p-8 max-h-[90vh] overflow-y-auto">
      <div class="flex justify-between items-center mb-6">
        <h2 class="text-2xl font-bold text-gray-800">
          <i class="fa fa-trash mr-2"></i>Papierkorb
        </h2>
        <button @click="$emit('close')" class="text-gray-700 hover:text-black text-3xl iconbutton admin-button--ghost admin-button--icon" aria-label="Schließen" title="Schließen">
          <i class="fa fa-xmark"></i>
        </button>
      </div>

      <div v-if="loading" class="text-center py-8">
        <i class="fa fa-spinner fa-spin text-3xl text-gray-400"></i>
        <p class="mt-2 text-gray-500">Lade Einträge...</p>
      </div>

      <div v-else-if="entries.length === 0" class="text-center py-8 text-gray-500">
        <i class="fa fa-trash text-4xl mb-3"></i>
        <p>Der Papierkorb ist leer.</p>
      </div>

      <div v-else>
        <table class="w-full text-sm border-collapse">
          <thead>
            <tr class="border-b-2 border-gray-400">
              <th class="text-left p-2">Gelöscht am</th>
              <th class="text-left p-2">Von</th>
              <th class="text-left p-2">Vertragsbeschreibung</th>
              <th class="text-left p-2">PersNr</th>
              <th class="text-left p-2">Datum von</th>
              <th class="text-left p-2">Soll von</th>
              <th class="text-left p-2">Aktionen</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="entry in entries" :key="entry.id" class="border-b border-gray-200 hover:bg-gray-50">
              <td class="p-2">{{ formatDate(entry.createdAt) }}</td>
              <td class="p-2">{{ entry.user }}</td>
              <td class="p-2">{{ entry.content?.Vertragsbeschreibung || '-' }}</td>
              <td class="p-2">{{ entry.content?.Mitarbeiternr || '-' }}</td>
              <td class="p-2">{{ entry.content?.Datum_von || '-' }}</td>
              <td class="p-2">{{ entry.content?.Soll_Von || '-' }}</td>
              <td class="p-2 whitespace-nowrap">
                <button
                  @click="restoreEntry(entry)"
                  class="bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700 mr-1 admin-button--secondary admin-button--sm"
                  title="Wiederherstellen" aria-label="Wiederherstellen"
                >
                  <i class="fa fa-rotate-left"></i>
                </button>
                <button
                  v-if="isAdmin"
                  @click="deleteEntry(entry)"
                  class="bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700 admin-button--danger admin-button--sm"
                  title="Endgültig löschen" aria-label="Endgültig löschen"
                >
                  <i class="fa fa-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="bannerText" class="mt-4 p-3 rounded" :class="bannerMode === 'error' ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'">
        {{ bannerText }}
      </div>
    </div>
  </div>
</template>

<script>
import CASP from "../CASP";

export default {
  name: "TrashcanModal",
  props: {
    token: String,
    isAdmin: Boolean,
  },
  emits: ['close', 'restored'],
  data() {
    return {
      entries: [],
      loading: false,
      bannerText: "",
      bannerMode: "success",
    };
  },
  mounted() {
    this.loadEntries();
  },
  methods: {
    loadEntries() {
      this.loading = true;
      CASP.getTrashcanEntries(this.token, (res) => {
        this.loading = false;
        if (res && Array.isArray(res)) {
          this.entries = res;
        } else {
          this.entries = [];
          this.showBanner("Fehler beim Laden der Einträge", "error");
        }
      });
    },
    restoreEntry(entry) {
      this.entries = this.entries.filter(e => e.id !== entry.id);
      this.$emit('restored', entry.content, entry.content?.Zeiterf_Buch_Blattname);
      this.showBanner("Auftrag wiederhergestellt — bitte speichern", "success");
    },
    deleteEntry(entry) {
      if (!confirm("Eintrag endgültig löschen? Dies kann nicht rückgängig gemacht werden.")) return;
      CASP.deleteTrashcanEntry(this.token, entry.id, (status, res) => {
        if (status === 200) {
          this.entries = this.entries.filter(e => e.id !== entry.id);
          this.showBanner("Eintrag endgültig gelöscht", "success");
        } else {
          this.showBanner(res?.desc || "Fehler beim Löschen", "error");
        }
      });
    },
    formatDate(dateStr) {
      if (!dateStr) return '-';
      const d = new Date(dateStr);
      return d.toLocaleString('de-DE', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    },
    showBanner(text, mode) {
      this.bannerText = text;
      this.bannerMode = mode;
      setTimeout(() => {
        this.bannerText = "";
      }, 4000);
    },
  },
};
</script>
